import React from 'react';
import { BsTwitter} from 'react-icons/bs';
import { FaFacebookF, FaGithub } from 'react-icons/fa';
import  './Footer.scss';


const Footer = () => {
  return (
    <>
      <footer>
      {/* <br></br>
        <br></br> */}
        <div className=' text-center '>

        <button className='btn_shadow'>
             <BsTwitter />
        </button>
        <button className='btn_shadow'>
              <FaFacebookF />
        </button>
        <button className='btn_shadow'>
        <a href='https://github.com/aldolo49'><FaGithub/></a>
        </button>
        {/* <ul class="menu">
              {['Accueil', 'Apropos', 'work', 'skills', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} >
                    {item}
                  </a>
                </li>
              ))}
            </ul> */}
          <p>Copyright © 2022 by <a href='#accueil' >Aldolo </a> </p>
        </div>
      </footer>
    </>
  )
}

export default Footer;
